<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <template v-slot:header>
          <strong>mGuage Pricing Rules</strong>
        </template>
        <b-row>
          <b-col md="3" class="my-0">
            <div style="height: 68vh; overflow: auto">
              <button class="btn btn-success" @click="createPolicy(activePartner)">
                <i class="fa fa-plus-square" title="Add a new rule"></i> <strong class="text-white">Add a new rule</strong>
              </button>
              <b-list-group>
                <b-list-group-item v-for="p in partners" button class="d-flex justify-content-between align-items-center" @click="selectPartner(p)" style="padding: 5px 5px 5px 20px;">
                  Rule {{ p.id == 0 ? 1 : p.id }}
                  <b-button variant="outline-primary" size="sm" @click="selectPartner(p)">
                    Vehicles:
                    <b-badge variant="primary" pill>{{ p.policy.length }}</b-badge>
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-col>
          <b-col md="9">
            <div v-if="activePartner">
              <b-row style="vertical-align: middle;padding-bottom:5px;">
                <b-col md="12" class="d-inline-flex">
                  <h4>Rule {{ activePartner.id == 0 ? 1 : activePartner.id }}</h4>
                </b-col>
              </b-row>
              <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                <tbody>
                  <tr v-if="!activePartner.policy.length" class="b-table-empty-row">
                    <td><div role="alert" aria-live="polite"><div class="text-center my-2">No rules created yet.</div></div></td>
                  </tr>
                  <tr v-for="(p, pi) in activePartner.policy">
                    <td>
                      <b-row style="padding-top:5px;">
                        <b-col md="12"><span class="badge badge-primary">ID:</span> {{ p.id }}</b-col>
                      </b-row>
                    </td>
                    <td>
                      <b-row style="padding-top:5px;padding-bottom:10px;">
                        <b-col md="6"><span class="badge badge-primary">Name:</span> {{ p.name }}</b-col>
                        <b-col md="6"><span class="badge badge-primary">Type:</span> {{ p.typeDescription }}</b-col>
                      </b-row>
                      <b-table v-if="p.vehicleRules" striped small head-variant="light" :items="p.vehicleRules" class="table-xtra-condensed"
                               :fields="[{key:'newused', label:'Type'},{key:'year', label:'Year'},{key:'make', label:'Make'},{key:'model', label:'Model'},{key:'trim', label:'Trim'}]">
                        <template v-slot:cell(newused)="row">
                          {{ row.value === 1 ? 'New' : 'Used' }}
                        </template>
                      </b-table>
                    </td>
                    <td>
                      <button class="btn btn-info text-white" @click="openPolicy(p.id)">
                        <i class="fa fa-edit" title="Edit"></i> <strong class="text-white">Edit</strong>
                      </button>
                      <button class="btn btn-danger text-white" @click="confirmDelete(p.id, pi)">
                        <i class="fa fa-trash-o" title="Delete"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <table class="table b-table table-striped table-hover table-bordered table-sm">
                <tbody class="">
                  <tr class="b-table-empty-row"><td><div role="alert" aria-live="polite"><div class="text-center my-2">Select a rule to edit.</div></div></td></tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>

      </b-card>
    </div>

    <loading :show="boolLoading"
              :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'

export default {
  components: {
    loading
  },
  created () {
    axios.get('/api/quotepolicy/loadlist')
      .then(response => {
        this.boolLoading = false
        this.partners = response.data.data
        if (this.partners) { this.activePartner = this.partners[0] }
      })
      .catch(error => {
        if (error.response.status === 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      activePartner: null,
      partners: []
    }
  },
  methods: {
    selectPartner (p) {
      this.activePartner = p
    },
    createPolicy (p) {
      window.localStorage.setItem('addquotingpolicy_partneridint', p.id)
      window.localStorage.setItem('addquotingpolicy_partner', p.name)
      this.$router.push('/mGauge/PricingRuleDetail/-1')
    },
    openPolicy (policyID) {
      this.$router.push('/mGauge/PricingRuleDetail/' + policyID)
    },
    confirmDelete (policyID, policyIndex) {
      var ctx = this
      this.$dialog.confirm('Are you sure you would like to proceed?')
        .then(function () {
          ctx.deletePolicy(policyID, policyIndex)
        })
        .catch(function () {
          // do nothing
        })
    },
    deletePolicy (policyID, policyIndex) {
      this.boolLoading = true
      axios.delete('/api/quotepolicy/save?id=' + policyID)
        .then(response => {
          this.boolLoading = false
          Vue.delete(this.activePartner.policy, policyIndex)
        })
        .catch(error => {
          if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error deleting data : ' + error
          this.showDismissibleAlert = true

          if (error.response.status === 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
        })
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>

<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/mGuagePricingRules.vue